var map = {
	"./463867761_3822636484732138_5971648607939521619_n.jpg": 5537,
	"./465013255_998577028978746_1026770565999156500_n.jpg": 7652,
	"./465019062_998063469030102_7880638483829218710_n.jpg": 1362,
	"./468681389_18049580467990916_4374295892608116550_n.jpg": 4604,
	"./468688065_18049820566990916_8668296183630100481_n.jpg": 1923,
	"./469254706_18050082907990916_4219382997509791904_n.jpg": 5212,
	"./473561302_18054492073990916_3674461542745470002_n.jpg": 4531,
	"./avental-flores.jpg": 6437,
	"./avental-mulher-africana.jpg": 5090,
	"./ballon-heart.jpg": 1667,
	"./bolsa-oculos-laranja.jpg": 5835,
	"./bolsa-oculos-roxo.jpg": 4935,
	"./brincos-feitos-a-mao.jpg": 4479,
	"./colares-feito-a-mao.jpg": 1439,
	"./conjunto-individuais-azul-amarelo.jpg": 9997,
	"./conjunto-individuais-azul-estrelas.jpg": 6729,
	"./conjunto-individuais-folhas-vermelho.jpg": 7821,
	"./crowdfounding-dez-2025-poster.jpg": 8787,
	"./cta.jpg": 2639,
	"./donate-apoiar-comunidades.jpg": 6718,
	"./donate-execucao-projects.jpg": 2188,
	"./donate-kits-escolares.jpg": 2490,
	"./donate-mensal-parcial.jpg": 8755,
	"./donate-mensal-total.jpg": 4058,
	"./donate-nutricao-criancas-vulneraveis.jpg": 4928,
	"./donate-pequenos-almocos.jpg": 5729,
	"./donate-pontual-1.jpg": 5711,
	"./donate-pontual-10-breakfast.jpg": 4854,
	"./donate-pontual-2-kits-oral.jpg": 4850,
	"./donate-pontual-2.jpg": 7524,
	"./donate-pontual-3.jpg": 9882,
	"./donate-pontual-4.jpg": 8353,
	"./donate-pontual-actividades-centro-comunitario-aquarela.jpg": 7669,
	"./donate-pontual-kit-escolar-uniforme.jpg": 5405,
	"./donate-pontual-placa-solar.jpg": 1854,
	"./features.jpg": 7168,
	"./header-404.jpg": 8500,
	"./header-about.jpg": 1675,
	"./header-contacts.jpg": 970,
	"./header-crowdfounding-2026.jpg": 8406,
	"./header-project-apoio-educacional.jpg": 8890,
	"./header-project-centro-comunitario-aquarela.jpg": 1290,
	"./header-project-sustentabilidade-alimentar.jpg": 8722,
	"./header-projects.jpg": 5675,
	"./header-solidarity-articles.jpg": 8730,
	"./homepage-thumbnail-breakfast.jpg": 1814,
	"./homepage-thumbnail-home-visits.jpg": 8103,
	"./homepage-thumbnail-library.jpg": 4821,
	"./homepage-thumbnail-parteners.jpg": 9296,
	"./homepage-thumbnail-tree-fruit.jpg": 4257,
	"./imans-caras-feito-a-mao.jpg": 6323,
	"./imans-feito-a-mao.jpg": 5869,
	"./partners-aquarela-adss.jpg": 6405,
	"./partners-compra-solidaria.jpg": 1896,
	"./partners-gentil-chiky-patas.jpg": 4374,
	"./partners-mym-yo.jpg": 988,
	"./partners-yoga-braga.jpg": 7401,
	"./pega-cozinha-dourado.jpg": 1949,
	"./pega-cozinha-laranja-azul.jpg": 7198,
	"./pega-cozinha-laranja.jpg": 2933,
	"./pega-cozinha-verde.jpg": 1826,
	"./photo-2025-02-16-20-23-40.jpg": 9209,
	"./photo-2025-02-16-20-32-33.jpg": 7681,
	"./photo-2025-02-16-20-32-34.jpg": 4862,
	"./photo-2025-02-16-20-36-35.jpg": 4918,
	"./photo-2025-02-16-20-36-36.jpg": 719,
	"./photo-2025-02-16-20-36-37.jpg": 8446,
	"./photo-2025-02-16-20-46-18.jpg": 4576,
	"./photo-2025-02-16-21-03-25.jpg": 1525,
	"./photo-2025-02-16-21-10-19.jpg": 3825,
	"./porta-chaves.jpg": 8858,
	"./porta-guardanapos-coloridas.jpg": 7439,
	"./porta-guardanapos-vermelho.jpg": 6295,
	"./projects-proj-apoio-deslocados-cabo-delgado.jpg": 98,
	"./projects-proj-apoio-educacional-IMG-20210406-WA0037.jpg": 6715,
	"./projects-proj-apoio-educacional-IMG-20210619-WA0016.jpg": 3243,
	"./projects-proj-apoio-educacional-IMG-20221015-WA0044.jpg": 4078,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0058.jpg": 8160,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0063.jpg": 8935,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0064.jpg": 9417,
	"./projects-proj-apoio-educacional-IMG-20230210-WA0083.jpg": 9072,
	"./projects-proj-apoio-educacional-f133e942-9d89-4c16-b810-f986d9a12094.jpg": 6753,
	"./projects-proj-apoio-educacional-kits-escolares.jpg": 997,
	"./projects-proj-apoio-educacional-pensos-higienicos-reutilizaveis.jpg": 958,
	"./projects-proj-apoio-educacional-uniformes-escolares.jpg": 3818,
	"./projects-proj-centro-comunitario-aquarela-kids-roundabout.jpg": 9179,
	"./projects-proj-centro-comunitario-aquarela.jpg": 4691,
	"./projects-proj-plantacao-fruto.jpg": 3109,
	"./projects-proj-sustentabilidade-alimentar-01.jpg": 9817,
	"./projects-proj-sustentabilidade-alimentar-02.jpg": 2250,
	"./projects-proj-sustentabilidade-alimentar-03.jpg": 7619,
	"./projects-proj-sustentabilidade-alimentar-04.jpg": 9952,
	"./projects-proj-sustentabilidade-alimentar-05.jpg": 7937,
	"./projects-proj-sustentabilidade-alimentar-06.jpg": 679,
	"./projects-thumbnail-apoio-educacional.jpg": 5576,
	"./projects-thumbnail-centro-comunitario-aquarela.jpg": 8821,
	"./projects-thumbnail-sustentabilidade-alimentar.jpg": 8959,
	"./pub-crowdfounding-2025.jpg": 6543,
	"./saco-bolsa-shop-verde.jpg": 3430,
	"./saco-bolsa-shop-vermelho.jpg": 7824,
	"./saco-bolsa-shop.jpg": 3116,
	"./saco-ombro.jpg": 7543,
	"./solidarity-articles-estatuetas.jpg": 7961,
	"./solidarity-articles-lembrancas-solidarias.jpg": 3353,
	"./team-01.jpg": 2803,
	"./team-02.jpg": 9244,
	"./team-03.jpg": 5151,
	"./team-04.jpg": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;